<ng-container>
  <div>
    <label
      appConfigSettingsParagraph
      class="displayInLine"
      *ngIf="placeholder != undefined"
      [style.color]="fontColor ? fontColor : null"
      [style.font-size.px]="fontSize ? fontSize : null"
    >
      <p>
        {{placeholderPrefix ? placeholderPrefix + ' ' : ''}}{{ placeholder | translate }}
      </p>
    </label>
    <div
      class="select-container"
      appConfigSettingsPrimaryButton
    >
      <div
        tabindex="0"
        appConfigSettingsBorder
        appConfigSettingsParagraph
        class="select-option"
        *ngFor="let option of selectOptions"
        (click)="selectOption(option)"
        (keydown.enter)="selectOption(option)"
        [ngClass]="{'selected': getSelectedValue === option.value, 'disabled': disabled}"
      >
        {{option.title | translate}}
      </div>
    </div>
  </div>
  <div>
    <mat-error *ngIf="isAnyError" class="error-message">
      <ng-container *ngIf="requiredError">
        {{ isRequiredMessage }}
      </ng-container>
    </mat-error>
  </div>
</ng-container>
